import { get } from 'lodash'

const isBasicPlus = () => {

  const type = get(window, 'state.user.type')

  return type === 'Admin' || type === 'Basic+' || type === 'Advanced' || type === 'Premium'

}

export default isBasicPlus
